module.exports = {
      id: "search-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#search",
      toString: function () {
        return this.url;
      }
    }